import { CircularProgress, IconButton, Stack } from '@mui/material';
import { ReactElement, } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetHeader, WidgetPerCustomerBody, WidgetWrapper } from '../shared/all.styles';
import { Typography } from '../shared/typography';
import { Link } from '@mui/icons-material';
import { theme } from '../theme';
import { format } from 'date-fns/format';
import { useNavigate } from 'react-router-dom';

interface Props {
  title: string;
  loading?: boolean;
  values?: any[];
  onLinkClick?: () => void;
}

export const WidgetReviewPerHospital = ({
  title,
  values,
  loading,
  onLinkClick,
}: Props): ReactElement => {
  const { t } = useTranslation();
  const navigate = useNavigate()



  return (
    <WidgetWrapper>
      <WidgetHeader>
        <Typography variant="subtitle2">{title}</Typography>
        {onLinkClick && (
          <IconButton onClick={() => navigate('/clusters')} color="primary" title="More">
            <Link />
          </IconButton>
        )}
      </WidgetHeader>

      <WidgetPerCustomerBody>
        {loading ? (
          <CircularProgress size={50} />
        ) : (
          <Stack>
            {values?.length ? (
              values?.map((el) => (
                <CustomerItem key={el.id_struttura} data={el} onLinkClick={onLinkClick} />
              ))
            ) : (
              <Typography color="success.main" variant="h5" fontWeight={500} fontSize={40}>
                {t('home.noData')}
              </Typography>
            )}
          </Stack>
        )}
      </WidgetPerCustomerBody>
    </WidgetWrapper>
  );
};

interface CustomerItemProps {
  data: any;
  onLinkClick?: () => void;
}

const CustomerItem = ({ data, onLinkClick }: CustomerItemProps): ReactElement => {
  const {t} = useTranslation()
  return (
    <Stack
      sx={{
        ':hover': {
          borderColor: 'primary.light',
        },
        border: '2px solid',
        borderColor: 'common.white',
        borderRadius: '10px',
      }}
      padding={'2px'}
      onClick={() => {}}
    >
      <Stack direction={'row'} justifyContent="space-between">
        <Stack direction={'row'} spacing={4} alignItems="center">
          <Typography>{data?.id_struttura}</Typography>
          <Typography variant='subtitle2' color={theme.palette.warning.main}>
            {data.count}
          </Typography>
        </Stack>
        {onLinkClick && (
          <div style={{ marginRight: '15px' }}>
            <IconButton
              onClick={() => {
                return onLinkClick();
              }}
              color="primary"
              title="More"
            >
              <Link />
            </IconButton>
          </div>
        )}
        <Typography>{t('home.lastIngestion')}: {format(new Date(data?.latest_data_imported_at), 'dd/MM/yyyy hh:mm')}</Typography>
      </Stack>
    </Stack>
  );
};
